export enum MapSidebarTabs {
  HOMES = 'homes',
  HOMESITES = 'homesites',
}
